
//
//   A class for preforming unit conversions
//

var UnitConversions = function(){
    this.Micrometers = {
        getInspectorName: function(){
            return "μm";
        },
        getNames: function(){
            return ["micrometers", "micrometer","μm", "um", "mic"];
        },
        toMillimeters: function(value){
            return value/1000;
        },
        toMils: function(value){
            return value * 0.03937;
        },
        toInches: function(value){
            return value / 25400;
        },
        toCentimeters: function(value){
            return value / 10000;
        },
        toMeters: function(value){
            return value / 1000000;
        },
        toFeet: function(value){
            return value / 304800;
        }
    }

    this.Millimeters = {
        getInspectorName: function(){
            return "mm";
        },
        getNames: function(){
            return ["millimeters", "millimeter", "mm"];
        },
        toMicrometers: function(value){
            return value * 1000;
        },
        toMils: function(value){
            return value * 39.37;
        },
        toInches: function(value){
            return value / 25.4;
        },
        toCentimeters: function(value){
            return value / 10;
        },
        toMeters: function(value){
            return value / 1000;
        },
        toFeet: function(value){
            return value / 305;
        }
    }

    this.Mils = {
        getInspectorName: function(){
            return "mil";
        },
        getNames: function(){
            return ["mils", "mil"];
        },
        toMillimeters: function(value){
            return value * 0.0254;
        },
        toMicrometers: function(value){
            return value * 25.4;
        },
        toInches: function(value){
            return value / 1000;
        },
        toCentimeters: function(value){
            return value / 393.701;
        },
        toMeters: function(value){
            return value / 39370;
        },
        toFeet: function(value){
            return value / 12000;
        }
    }

    this.Inches = {
        getInspectorName: function(){
            return "in";
        },
        getNames: function(){
            return ["inches", "inch", "in", "inch"];
        },
        toMillimeters: function(value){
            return value * 25.4;
        },
        toMicrometers: function(value){
            return value * 25400;
        },
        toMils: function(value){
            return value * 1000;
        },
        toCentimeters: function(value){
            return value * 2.5400013716;
        },
        toMeters: function(value){
            return value / 39.37;
        },
        toFeet: function(value){
            return value / 12;
        }
    }

    this.Centimeters = {
        getInspectorName: function(){
            return "cm";
        },
        getNames: function(){
            return ["centimeters", "centimeter", "cm"];
        },
        toMillimeters: function(value){
            return value * 10;
        },
        toMicrometers: function(value){
            return value * 10000;
        },
        toMils: function(value){
            return value * 393.701;
        },
        toInches: function(value){
            return value * 0.393701;
        },
        toMeters: function(value){
            return value / 100;
        },
        toFeet: function(value){
            return value / 30.48;
        }
    }
    
    this.Feet = {
        getInspectorName: function(){
            return "ft";
        },
        getNames: function(){
            return ["feet", "ft"];
        },
        toMillimeters: function(value){
            return value * 305;
        },
        toMicrometers: function(value){
            return value * 304800;
        },
        toMils: function(value){
            return value * 12000;
        },
        toCentimeters: function(value){
            return value * 30.48;
        },
        toInches: function(value){
            return value * 12;
        },
        toMeters: function(value){
            return value / 3.281;
        }
    }
    
    this.Meters = {
      getInspectorName: function(){
          return "m";
      },
      getNames: function(){
          return ["meters", "m"];
      },
      toMillimeters: function(value){
          return value * 1000;
      },
      toMicrometers: function(value){
          return value * 1000000;
      },
      toMils: function(value){
          return value * 39370;
      },
      toCentimeters: function(value){
          return value * 100;
      },
      toInches: function(value){
          return value * 39.37;
      },
      toFeet: function(value){
          return value * 3.281;
      }
    }

    this.Percent = {
        getInspectorName: function(){
            return "%";
        },
        getNames: function(){
            return ["%"];
        }
    }

    this.Degrees = {
        getInspectorName: function(){
            return "deg";
        },
        getNames: function(){
            return ["degrees", "degree", "deg", "°"];
        },
        toRadians: function(value){
            return value * Math.PI / 180;
        }
    }

    this.Radians = {
        getInspectorName: function(){
            return "rad";
        },
        getNames: function(){
            return ["radians", "radian", "rad"];
        },
        toDegrees: function(value){
            return value * 180 / Math.PI;
        }
    }

    // ADD ALL NEW UNIT SUBCLASSES TO THIS LIST!!!!
    this.units = [this.Micrometers, this.Millimeters, this.Mils, this.Inches, this.Centimeters, this.Feet, this.Meters, this.Percent, this.Degrees, this.Radians];
    
    this.distanceUnits = [this.Micrometers, this.Millimeters, this.Mils, this.Inches, this.Centimeters, this.Feet, this.Meters];
    this.rotationalUnits = [this.Degrees, this.Radians];
  
    this.distanceDataUnit = this.Micrometers;
    this.rotationDataUnit = this.Degrees;
    this.defaultDisplayUnit = this.Millimeters;

    // all subclasses need a function to check if a type is allowed (name match)
    // and a types list (for subclasses it always just point to themselves, 
        // this is so isAllowedType works with string or class)
    for(var i = 0; i < this.units.length; i++){
        this.units[i].units = [this.units[i]];
        this.units[i].isAllowedUnit = this.isAllowedUnit;
    }
}; 

// can take in a string or a unit object.  function is also used over entire class,
// and within each unit subclass
UnitConversions.prototype.isAllowedUnit = function(unit){
    // in the context of this function 'this' 
    // could mean the superclass or a unit subclass
    if(typeof unit == "string"){
        unit = unit.toLowerCase();
        return this.getNames().indexOf(unit) != -1;
    } else {
        return this.units.indexOf(unit) != -1;
    }
}

UnitConversions.prototype.getDistanceInspectorNames = function(unit){
    // in the context of this function 'this' 
    // could mean the superclass or a unit subclass
    var names = [];
    for(var i = 0; i < this.distanceUnits.length; i++){
        names.push( this.distanceUnits[i].getInspectorName() );
    }
    return names;
}

UnitConversions.prototype.getRotationInspectorNames = function(unit){
    // in the context of this function 'this' 
    // could mean the superclass or a unit subclass
    var names = [];
    for(var i = 0; i < this.rotationalUnits.length; i++){
        names.push( this.rotationalUnits[i].getInspectorName() );
    }
    return names;
}

// get the names of all possible units
UnitConversions.prototype.getNames = function(){
    var allNames = [];
    for(var i = 0; i < this.units.length; i++){
        for(var j = 0; j < this.units[i].getNames().length; j++){
            allNames = allNames.concat(this.units[i].getNames()[j]);
        }
    }
    return allNames;
}

// remove the number part of the string to read units
UnitConversions.prototype.removeNumericalChars = function(str, isPositive, isInt){

    //if can be negative and have one remove
    if(!isPositive){
        if(str.charAt(0) == '-'){
            str = str.slice(1);
        }
    }
   
    // if while numbers remove
    while(!isNaN(parseInt(str.charAt(0))) ){
        str = str.slice(1);
    }

    var hasDecimal = false;
    // if decimal, and number following, remove
    if(str.charAt(0) == '.' && !isNaN(parseInt(str.charAt(1))) ){
        str = str.slice(1);
        hasDecimal = true;
        // remove numbers after decimal
        while(!isNaN(parseInt(str.charAt(0))) ){
            str = str.slice(1);
        }
    }

    // if scifi notation, and number following, remove
    if(str.charAt(0) == 'e' && (!isNaN(parseInt(str.charAt(1))) || str.charAt(1) == '-') ){
        // remove e
        str = str.slice(1);

        // remove neg if neg
        if(str.charAt(0) == '-'){
            str = str.slice(1);
        }

        // remove scifi numbers
        while(!isNaN(parseInt(str.charAt(0))) ){
            str = str.slice(1);
        }

        // scifi notation cannot have decimal
    } else {
        // if not scifi note, and supposed to be integer,
        // should not have removed decimal
        if(hasDecimal && isInt){
            str += '.';
        }
    }

    return str;
}

// find the unit at the end of a string.  
// front part could be complex...   
// like -2.0πe10mm needs to give mm.
UnitConversions.prototype.getUnit = function(str){
    str = str.toLowerCase();
    str = this.removeNumericalChars(str);
    str = str.trim(); // trim trailing spaces
    str = str.split(" "); // split by spaces
    str = str[str.length - 1]; // grab last word, that is unit
    return str;
}

// remove the trailing unit
UnitConversions.prototype.trimUnit = function(str){
    if(!this.hasUnit(str)) return str;
    var unit = this.getUnit(str);
    str = str.replace(unit, '');
    return str;
}

UnitConversions.prototype.hasUnit = function(str){
    if(typeof str != "string") return false;
    str = this.getUnit(str);
    if(str == ""){
        // if no unit
        return false;
    } else {
        // has some unit
        return true;
    }
}

UnitConversions.prototype.parseUnit = function(str){
    if(typeof str != "string") return null;
    str = this.getUnit(str);

    var foundType = null;
    for(var i = 0; i < this.units.length; i++){
       for(var j = 0; j < this.units[i].getNames().length; j++){
            if(this.units[i].getNames()[j] == str){
                return this.units[i];
            }
        }
    }
    // return found unit or null if fail
    return foundType;
}

// can pass in either strings or unit subclasses
UnitConversions.prototype.convert = function(from_type, to_type, value){
    console.assert(this.isAllowedUnit(from_type), "unrecognized unit "+ from_type);
    console.assert(this.isAllowedUnit(to_type),   "unrecognized unit "+ to_type);

    if(this.Millimeters.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return value;
        else if(this.Micrometers.isAllowedUnit(to_type)) return this.Millimeters.toMicrometers(value);
        else if(this.Mils.isAllowedUnit(to_type))        return this.Millimeters.toMils(value);
        else if(this.Inches.isAllowedUnit(to_type))      return this.Millimeters.toInches(value);
        else if(this.Centimeters.isAllowedUnit(to_type)) return this.Millimeters.toCentimeters(value);
        else if(this.Feet.isAllowedUnit(to_type))        return this.Millimeters.toFeet(value);
        else if(this.Meters.isAllowedUnit(to_type))      return this.Millimeters.toMeters(value);
    }
    else if(this.Micrometers.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return this.Micrometers.toMillimeters(value);
        else if(this.Micrometers.isAllowedUnit(to_type)) return value;
        else if(this.Mils.isAllowedUnit(to_type))        return this.Micrometers.toMils(value);
        else if(this.Inches.isAllowedUnit(to_type))      return this.Micrometers.toInches(value);
        else if(this.Centimeters.isAllowedUnit(to_type)) return this.Micrometers.toCentimeters(value);
        else if(this.Feet.isAllowedUnit(to_type))        return this.Micrometers.toFeet(value);
        else if(this.Meters.isAllowedUnit(to_type))      return this.Micrometers.toMeters(value);
    }
    else if(this.Mils.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return this.Mils.toMillimeters(value);
        else if(this.Micrometers.isAllowedUnit(to_type)) return this.Mils.toMicrometers(value);
        else if(this.Mils.isAllowedUnit(to_type))        return value;
        else if(this.Inches.isAllowedUnit(to_type))      return this.Mils.toInches(value);
        else if(this.Centimeters.isAllowedUnit(to_type)) return this.Mils.toCentimeters(value);
        else if(this.Feet.isAllowedUnit(to_type))        return this.Mils.toFeet(value);
        else if(this.Meters.isAllowedUnit(to_type))      return this.Mils.toMeters(value);
    }
    else if(this.Inches.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return this.Inches.toMillimeters(value);
        else if(this.Micrometers.isAllowedUnit(to_type)) return this.Inches.toMicrometers(value);
        else if(this.Mils.isAllowedUnit(to_type))        return this.Inches.toMils(value);
        else if(this.Inches.isAllowedUnit(to_type))      return value;
        else if(this.Centimeters.isAllowedUnit(to_type)) return this.Inches.toCentimeters(value);
        else if(this.Feet.isAllowedUnit(to_type))        return this.Inches.toFeet(value);
        else if(this.Meters.isAllowedUnit(to_type))      return this.Inches.toMeters(value);
    }
    else if(this.Centimeters.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return this.Centimeters.toMillimeters(value);
        else if(this.Micrometers.isAllowedUnit(to_type)) return this.Centimeters.toMicrometers(value);
        else if(this.Mils.isAllowedUnit(to_type))        return this.Centimeters.toMils(value);
        else if(this.Inches.isAllowedUnit(to_type))      return this.Centimeters.toInches(value);
        else if(this.Centimeters.isAllowedUnit(to_type)) return value;
        else if(this.Feet.isAllowedUnit(to_type))        return this.Centimeters.toFeet(value);
        else if(this.Meters.isAllowedUnit(to_type))      return this.Centimeters.toMeters(value);
    }
    else if(this.Feet.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return this.Feet.toMillimeters(value);
        else if(this.Micrometers.isAllowedUnit(to_type)) return this.Feet.toMicrometers(value);
        else if(this.Mils.isAllowedUnit(to_type))        return this.Feet.toMils(value);
        else if(this.Inches.isAllowedUnit(to_type))      return this.Feet.toInches(value);
        else if(this.Centimeters.isAllowedUnit(to_type)) return this.Feet.toCentimeters(value);
        else if(this.Feet.isAllowedUnit(to_type))        return value;
        else if(this.Meters.isAllowedUnit(to_type))      return this.Feet.toMeters(value);
    }
    else if(this.Meters.isAllowedUnit(from_type)){
        if(this.Millimeters.isAllowedUnit(to_type))      return this.Meters.toMillimeters(value);
        else if(this.Micrometers.isAllowedUnit(to_type)) return this.Meters.toMicrometers(value);
        else if(this.Mils.isAllowedUnit(to_type))        return this.Meters.toMils(value);
        else if(this.Inches.isAllowedUnit(to_type))      return this.Meters.toInches(value);
        else if(this.Centimeters.isAllowedUnit(to_type)) return this.Meters.toCentimeters(value);
        else if(this.Feet.isAllowedUnit(to_type))        return this.Meters.toFeet(value);
        else if(this.Meters.isAllowedUnit(to_type))      return value;
    }
    else if(this.Percent.isAllowedUnit(from_type)){
        if(this.Percent.isAllowedUnit(to_type)) return value;
    }

    else if(this.Degrees.isAllowedUnit(from_type)){
        if(this.Radians.isAllowedUnit(to_type))          return this.Degrees.toRadians(value);
        else if(this.Degrees.isAllowedUnit(to_type))     return value;
    }
    else if(this.Radians.isAllowedUnit(from_type)){
        if(this.Radians.isAllowedUnit(to_type))          return value;
        else if(this.Degrees.isAllowedUnit(to_type))     return this.Radians.toDegrees(value);
    }

    return null;
}

// initialize singleton
var Converter = new UnitConversions();

module.exports = Converter;
